import { useGetBuildings } from "../../../hooks/useGetBuildings";
import { LoadingView } from "../../../components";
import { AutomationObjectsFlexGridView } from "../../components/Grid/AutomationObjectsFlexGridView";
import { useGetObjectsChildren } from "../../../hooks/useGetObjectsChildren";
import { IPortfolioInsights } from "./types";

const PortfolioInsights = (props: IPortfolioInsights) => {
    const { children, isLoading, isSuccess, error } = useGetObjectsChildren(props.resourceGroupId,props.id)
    const { items: buildings, isLoading: isLoadingB, isSuccess: isSuccessB } = useGetBuildings();


    return (
        <LoadingView  isLoading={isLoading || isLoadingB} isSucess={isSuccess && isSuccessB} error={error}>
           { children &&  <AutomationObjectsFlexGridView items={children} flexGridColumnCount={[1, 1, 2, 2]} additionalState={{ buildings: buildings }}></AutomationObjectsFlexGridView>}
        </LoadingView>
    )
}

export default PortfolioInsights;